var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-inline-block",staticStyle:{"max-width":"100%"}},[_c('v-avatar',{attrs:{"tile":_vm.tile,"size":_vm.size}},[(_vm.photoUrl != null)?[_c('v-img',{attrs:{"src":_vm.photoUrl,"alt":("" + _vm.schoolName)}})]:_vm._e()],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }